import React from 'react';
import styled from '@emotion/styled';
import { getGravatar } from 'utils/getGravatar';
import { SmallGrayText } from 'components/typography';
import { Author } from 'data/SingleArticle/types';
import { mediaQueries } from 'components/mediaQueries';
import { Colors, Link, Typography } from '@zapier/design-system';

type Props = { author: Author };

export const AuthorFeature = ({ author }: Props) => {
  return (
    <LinkOverride href={`/blog/author/${author.internalName}`} target="_blank">
      <ContentWrapper>
        <Image
          src={author.image || getGravatar(author.email)}
          alt={author.name + ' picture'}
        />
        <div>
          <Name>{author.name}</Name>
          <SmallGrayText>{author.bio}</SmallGrayText>
        </div>
      </ContentWrapper>
    </LinkOverride>
  );
};

const LinkOverride = styled(Link)`
  text-decoration: none;
`;

const ContentWrapper = styled.div`
  align-items: center;
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 1fr;
  padding: 0 22px;
  ${mediaQueries.tablet} {
    grid-template-columns: 70px auto;
  }
`;

const Image = styled.img`
  border-radius: 50%;
  object-fit: cover;
  width: 70px;
  height: 70px;
`;

const Name = styled.p`
  color: ${Colors.neutral800};
  margin-bottom: 5px;
  ${Typography.smallPrint1Bold};
`;
